import { useEffect } from "react";

const AutomatticConsoleMessage = () => {
  useEffect(() => {
    console.log(`
                         ___.          .__       .___._.
   ____   ____   \_ |__ _____  |  |    __| _/| |
  / ___\ /  _ \   | __ \\__  \ |  |   / __ | | |
 / /_/  >  <_> )  | \_\ \/ __ \|  |__/ /_/ |  \|
 \___  / \____/   |___  (____  /____/\____ |  __
/_____/               \/     \/           \/  \/
    `);
  }, []);

  return null; // This ensures nothing renders on the page
};

export default AutomatticConsoleMessage;
